(function () {
  "use strict";

  /* â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
     CONFIG
  â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€ */
  const STORAGE_KEY      = "member_verified";
  const VALIDATE_ENDPOINT = "https://chatmobile-sp5der.rebelware.io/validate";
  const CHATMOBILE_URL   = "https://chatmobile.com";
  const LOGO_URL         = "https://cdn.rebelwarecdn.com/kingspider.co/scripts/logo-chat.png";
  const HOME_URL         = "/";

  /* â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
     GATE CHECK â€“ if already verified, do nothing
  â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€ */
  if (localStorage.getItem(STORAGE_KEY)) return;

  /* â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
     PAGE TYPE DETECTION
  â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€ */
  var path  = window.location.pathname;
  var isPDP = /^\/products\//.test(path);

  /* â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
     HIDE PAGE CONTENT
     Collection : product grid custom element + background
     PDP        : product media column, product details column,
                  and the on-model imagery section
  â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€ */
  var selectorsToHide = isPDP
    ? [
        ".product-information__media",
        ".product-details",
        ".section-on-model",
        "product-recommendations",
      ]
    : [
        "results-list",
        ".section-background.page-load-gated",
      ];

  selectorsToHide.forEach(function (sel) {
    document.querySelectorAll(sel).forEach(function (el) {
      el.style.display = "none";
    });
  });

  /* â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
     BUILD THE VERIFICATION FORM
  â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€ */
  var headline  = isPDP ? "Exclusive Product"   : "Exclusive Collection";
  var introCopy = isPDP
    ? "This product is reserved for the <strong>Ch@mobile</strong> community. Enter your mobile number below to verify your membership and unlock this product."
    : "Reserved for the <strong>Ch@mobile</strong> community. Enter your mobile number below to verify your membership and unlock the collection.";
  var successMsg = isPDP ? "Verified! Loading productâ€¦" : "Verified! Loading collectionâ€¦";

  var container = document.createElement("div");
  container.id = "cm-gate";
  container.innerHTML = [
    '<div id="cm-gate-inner">',

    /* Back to home */
    '  <a id="cm-back" href="' + HOME_URL + '">&#8592; Back to Home</a>',

    /* Logo */
    '  <img id="cm-logo" src="' + LOGO_URL + '" alt="Ch@mobile" />',

    /* Headline + intro */
    '  <h1 id="cm-headline">' + headline + '</h1>',
    '  <p id="cm-intro">' + introCopy + '</p>',

    /* Form */
    '  <form id="cm-form" autocomplete="off">',
    '    <label for="cm-phone" id="cm-label">Mobile Phone Number</label>',
    '    <input id="cm-phone" type="tel" placeholder="(555) 123-4567"',
    '           required autocomplete="tel" />',
    '    <button id="cm-submit" type="submit">VERIFY &amp; SHOP</button>',
    '  </form>',

    /* Status / error */
    '  <p id="cm-status" role="alert"></p>',
    '  <div id="cm-error-cta" style="display:none;">',
    '    <p>Want access to exclusive drops like this?</p>',
    '    <a id="cm-join-btn" href="' + CHATMOBILE_URL + '?utm_source=kingspider.co&utm_medium=referral" target="_blank" rel="noopener">',
    '      JOIN CH@MOBILE',
    '    </a>',
    '  </div>',

    '</div>',
  ].join("\n");

  /* â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
     INJECT STYLES (scoped to #cm-gate)
  â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€ */
  var style = document.createElement("style");
  style.textContent = [

    /* Gate wrapper â€” full-width, min 85vh so it dominates the page */
    "#cm-gate {",
    "  display:flex; justify-content:center; align-items:center;",
    "  width:100%; min-height:85vh; padding:60px 20px 80px;",
    "  box-sizing:border-box;",
    "  font-family:-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,Helvetica,Arial,sans-serif;",
    "}",

    /* Inner card */
    "#cm-gate-inner {",
    "  max-width:480px; width:100%; text-align:center;",
    "  display:flex; flex-direction:column; align-items:center;",
    "  background:#fff;",
    "  border-radius:12px;",
    "  padding:48px 40px 52px;",
    "  box-shadow:0 2px 8px rgba(0,0,0,.06), 0 8px 24px rgba(0,0,0,.08), 0 24px 48px rgba(0,0,0,.06);",
    "}",

    /* Back link â€” sits above the logo, left-aligned within the card */
    "#cm-back {",
    "  align-self:flex-start;",
    "  font-size:13px; font-weight:600; letter-spacing:.5px;",
    "  color:#555; text-decoration:none;",
    "  margin-bottom:32px;",
    "  transition:color .2s;",
    "}",
    "#cm-back:hover { color:#000; }",

    /* Logo */
    "#cm-logo {",
    "  display:block; max-width:280px; width:100%; height:auto;",
    "  margin:0 auto 32px;",
    "}",

    /* Headline */
    "#cm-headline {",
    "  font-size:32px; font-weight:800; letter-spacing:1px;",
    "  text-transform:uppercase; margin:0 0 16px; color:#000;",
    "}",

    /* Intro copy */
    "#cm-intro {",
    "  font-size:15px; line-height:1.65; color:#444; margin:0 0 36px;",
    "}",
    "#cm-intro strong { color:#000; }",

    /* Form */
    "#cm-form {",
    "  display:flex; flex-direction:column; gap:12px;",
    "  margin-bottom:20px; width:100%;",
    "}",

    "#cm-label {",
    "  font-size:12px; font-weight:600; letter-spacing:1.5px;",
    "  text-transform:uppercase; text-align:left; color:#333;",
    "}",

    "#cm-phone {",
    "  width:100%; padding:14px 16px; font-size:16px;",
    "  border:2px solid #ccc; border-radius:6px; outline:none;",
    "  transition:border-color .2s; box-sizing:border-box;",
    "}",
    "#cm-phone:focus { border-color:#000; }",

    "#cm-submit {",
    "  width:100%; padding:16px; font-size:14px; font-weight:700;",
    "  letter-spacing:2px; text-transform:uppercase; color:#fff;",
    "  background:#000; border:none; border-radius:6px; cursor:pointer;",
    "  transition:opacity .2s;",
    "}",
    "#cm-submit:hover { opacity:.85; }",
    "#cm-submit:disabled { opacity:.5; cursor:wait; }",

    /* Status */
    "#cm-status {",
    "  font-size:14px; min-height:22px; margin:0;",
    "}",
    "#cm-status.error   { color:#c0392b; }",
    "#cm-status.success { color:#27ae60; }",

    /* Error CTA */
    "#cm-error-cta {",
    "  margin-top:24px; padding-top:24px;",
    "  border-top:1px solid #e0e0e0; width:100%;",
    "}",
    "#cm-error-cta p {",
    "  font-size:14px; color:#555; margin:0 0 14px;",
    "}",

    "#cm-join-btn {",
    "  display:inline-block; padding:14px 36px; font-size:13px;",
    "  font-weight:700; letter-spacing:2px; text-transform:uppercase;",
    "  color:#000; border:2px solid #000; border-radius:6px;",
    "  text-decoration:none; transition:all .2s;",
    "}",
    "#cm-join-btn:hover { background:#000; color:#fff; }",

  ].join("\n");

  document.head.appendChild(style);

  /* â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
     INJECT GATE INTO PAGE
     PDP        : prepend inside .product-information
     Collection : prepend inside #MainContent
     Fallback   : prepend inside main
  â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€ */
  var mountTarget;

  if (isPDP) {
    mountTarget = document.querySelector(".product-information");
  } else {
    mountTarget = document.querySelector("#MainContent") ||
                  document.querySelector("main");
  }

  if (!mountTarget) {
    mountTarget = document.querySelector("#MainContent") ||
                  document.querySelector("main");
  }

  if (mountTarget) {
    mountTarget.insertBefore(container, mountTarget.firstChild);
  }

  /* â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
     FORM SUBMISSION
  â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€ */
  var form       = document.getElementById("cm-form");
  var phoneInput = document.getElementById("cm-phone");
  var submitBtn  = document.getElementById("cm-submit");
  var statusEl   = document.getElementById("cm-status");
  var errorCta   = document.getElementById("cm-error-cta");

  form.addEventListener("submit", function (e) {
    e.preventDefault();

    var digits = phoneInput.value.replace(/\D/g, "");
    if (digits.length === 11 && digits.charAt(0) === "1") {
      /* Already includes country code â€” use as-is */
    } else if (digits.length === 10) {
      digits = "1" + digits;
    } else {
      statusEl.className = "error";
      statusEl.textContent = "Please enter a valid 10-digit phone number.";
      return;
    }
    var phone = digits;

    /* UI â†’ loading state */
    submitBtn.disabled = true;
    submitBtn.textContent = "VERIFYINGâ€¦";
    statusEl.textContent = "";
    statusEl.className = "";
    errorCta.style.display = "none";

    var url = VALIDATE_ENDPOINT + "?phone=" + encodeURIComponent(phone);

    fetch(url, { method: "GET" })
      .then(function (res) {
        if (!res.ok) {
          throw new Error("Verification failed (status " + res.status + ")");
        }
        return res.json();
      })
      .then(function (data) {
        if (!data || data.state !== "ACTIVE") {
          throw new Error(
            (data && (data.message || data.error)) ||
              "We couldn't verify this number as an active Ch@mobile member."
          );
        }

        /* SUCCESS */
        localStorage.setItem(STORAGE_KEY, JSON.stringify({
          verified: true,
          phone: phone,
          state: data.state,
          timestamp: new Date().toISOString(),
        }));
        statusEl.className = "success";
        statusEl.textContent = successMsg;
        setTimeout(function () {
          location.reload();
        }, 800);
      })
      .catch(function (err) {
        /* FAILURE */
        submitBtn.disabled = false;
        submitBtn.textContent = "VERIFY & SHOP";
        statusEl.className = "error";
        statusEl.textContent = err.message || "Something went wrong. Please try again.";
        errorCta.style.display = "block";
      });
  });

})();